<template>
  <v-dialog v-model="dOpenComponent" persistent full-width>
    <v-card>
      <!-- cabecera del dialogo -->
      <v-toolbar dark class="datModalTitleContainer">
        <v-toolbar-title>
          {{ dInformeComponente.nombre }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="fCerrarVentana()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-dialog v-if="dOpenComponent" v-model="dLoading" hide-overlay persistent width="300">
        <v-card class="datModalTitleContainer" dark>
          <v-card-text>
            {{ $t('cargandoContenido') }}
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-form ref="form" lazy-dValidation>
        <v-layout v-if="cRoleUser === 'ADMIN' || cRoleUser === 'REPRESENTANTE'" row wrap justify-end>
          <v-flex xs12 text-xs-right>
            <v-btn class="datSecondaryBtn" small flat tile @click="dFiltroActivo = !dFiltroActivo">
              <span v-show="dScreenWidth > 500 ? true : false">{{ $t('buscadorAvanzado') }}</span>
              <v-icon small :right="dScreenWidth > 500 ? true : false"
                v-if="dFiltroActivo === false">mdi-filter-plus</v-icon>
              <v-icon small :right="dScreenWidth > 500 ? true : false" v-else>mdi-filter-minus</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-card-text>
          <div class="subheading font-weight-bold mt-2 mb-2 px-3">{{ dInformeComponente.descripcion }}</div>
        </v-card-text>
        <v-layout row wrap>
          <v-flex xs12 ml-3 mr-3>
            <v-layout row wrap>
              <v-flex md12 px-2>
                <label>{{ this.$t("aplicarFiltrosYcomenzar") }}</label>
              </v-flex>
              <v-flex md12 px-2>
                <v-layout>
                  <v-flex md3 px-2>
                    <v-menu :ref="dDatosFiltros.fechaIniMenu" lazy v-model="dDatosFiltros.fechaIniMenu"
                      transition="scale-transition" offset-y full-width :nudge-right="40" min-width="290px"
                      :close-on-content-click="false">
                      <v-text-field required clearable color="data-colorcorp1" slot="activator"
                        :label="$t('fechaInicial')" v-model="dDatosFiltros.fechaIniString" append-icon="event"
                        readonly></v-text-field>
                      <v-date-picker required :min="dDatosFiltros.fechaMinIni" clearable
                        v-model="dDatosFiltros.fechaIni" no-title scrollable :first-day-of-week="1" locale="es-es"
                        @input="fGetFecha(dDatosFiltros.fechaIni, 'ini')"></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex md3 px-2>
                    <v-menu :ref="dDatosFiltros.fechaFinMenu" lazy v-model="dDatosFiltros.fechaFinMenu"
                      transition="scale-transition" offset-y full-width :nudge-right="40" min-width="290px"
                      :close-on-content-click="false">
                      <v-text-field required clearable color="data-colorcorp1" slot="activator"
                        :label="$t('fechaFinal')" v-model="dDatosFiltros.fechaFinString" append-icon="event"
                        readonly></v-text-field>
                      <v-date-picker required :min="dDatosFiltros.fechaMinFin" clearable
                        v-model="dDatosFiltros.fechaFin" no-title scrollable :first-day-of-week="1" locale="es-es"
                        @input="fGetFecha(dDatosFiltros.fechaFin, 'fin')"></v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex md3 px-2>
                    <v-text-field v-model="dDatosFiltros.numCertificado"
                      :label="this.$t('numCertificado')"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

            </v-layout>
            <v-layout v-if="(cRoleUser === 'ADMIN' || cRoleUser === 'REPRESENTANTE') && dFiltroActivo" row wrap>

              <v-flex md12 px-2>
                <label>{{ $t("advancedFilters") }}</label>
              </v-flex>
              <v-flex xs12 sm6 md4 px-2 v-if="dRole !== 'CLIENTE' && dRole !== 'SUCURSAL'">
                <p class="datLabelGroup pt-0">
                  {{ $t('cliente') }}
                </p>
                <DatTextFieldCode ref="TablaDeClientes" :pDataPass="dDataClient" @alert="fAlert" @select="fSelectClient"
                  @clean="fCleanClient"></DatTextFieldCode>
                <DatTextFieldCode v-if="dRole !== 'SUCURSAL' && !dIsOnPremise" ref="TablaDeSucursal"
                  :pDataPass="dDataSucursal" @select="fSelectSucursal" @clean="fClearSucursal"></DatTextFieldCode>
              </v-flex>
              <v-flex></v-flex>
              <v-flex md3 my-10 px-2>
                <p class="datLabelGroup pt-0">
                  {{ $t('otrosFiltros') }}
                </p>
                <v-select clearable :items="dAgencias" item-value="id" item-text="text"
                  v-model="dDatosFiltros.agenciaTrans" @change="fSelect($event, 'agencia')"
                  :label="this.$t('agenciaTransporte')"></v-select>
              </v-flex>
              <v-flex md3 my-10 px-2>
              </v-flex>
            </v-layout>
            <v-layout v-else>
              <template v-if="dRole !== 'SUCURSAL'">
                <v-flex v-if="dRole !== 'CLIENTE'" md5 px-2>
                  <DatTextFieldCode ref="TablaDeClientes" :pDataPass="dDataClient" @select="fSelectClient"
                    @clean="fCleanClient" @alert="fAlert"></DatTextFieldCode>
                </v-flex>
                <v-flex md5 px-3>
                  <DatTextFieldCode v-if="!dIsOnPremise" ref="TablaDeSucursal" :pDataPass="dDataSucursal"
                    @select="fSelectSucursal" @clean="fClearSucursal" @alert="fAlert"></DatTextFieldCode>
                </v-flex>
              </template>
            </v-layout>
            <v-flex xs12 text-xs-right>
              <v-btn @click="fPrepareCertificates()" class="datSecondaryBtn" small flat tile>{{ $t('buscar') }}</v-btn>
            </v-flex>
          </v-flex>
        </v-layout>
        <v-flex>
          <v-layout row wrap>
            <v-flex text-xs-center class="mb-3">
              <v-data-table item-key="rn" :loading="dLoading" single-expand :no-results-text="this.$t('noResultados')"
                :no-data-text="this.$t('noResultados')" :rows-per-page-text="$t('numCertifPagina')"
                v-bind:pagination.sync="dPaginationPED" :total-items="dTotalItems" class="tablePedidos"
                :rows-per-page-items="dRowsPerPageItemsPED" :items="dDatosTabla" :headers="dHeadersTable">
                <template slot="headers" slot-scope="props">
                  <tr class="lightPrimaryColorBackground">
                    <th class="text-xs-center" v-for="header in props.headers" :key="header.text" :id="header.value"
                      :class="['column sortable', dPaginationPED.descending ? 'desc' : 'asc', header.value === dPaginationPED.sortBy ? 'active' : header.class, 'text-xs-' + header.align + ' ' + header.class + ' ']"
                      @click="fCambiaOrden(header.value)">
                      <v-icon v-if="header.sortable">arrow_upward</v-icon>
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <template slot="items" slot-scope="props">
                  <tr>
                    <td class="text-xs-center pr-0 pl-2" width="40px" @click="fGetDetCertificados(props)">
                      <v-icon :class="props.expanded ? 'iconRotate cursorPointer' : 'cursorPointer'">
                        arrow_downward
                      </v-icon>
                    </td>
                    <td class="text-xs-center ellipsis">
                      <span>{{ props.item.Cliente }}</span>
                    </td>
                    <td class="text-xs-center ellipsis">
                      <span>{{ props.item.Sucursal }}</span>
                    </td>
                    <td class="text-xs-center ellipsis">
                      <span>{{ props.item.Nombre }}</span>
                    </td>
                    <td class="text-xs-center ellipsis">
                      <span>{{ props.item.NumCertificado }}</span>
                    </td>
                    <td class="text-xs-center ellipsis">
                      <span>{{ props.item.Ejercicio }}</span>
                    </td>
                    <td class="text-xs-center ellipsis">
                      <span>{{ props.item.MesInicial }}</span>
                    </td>
                    <td class="text-xs-center ellipsis">
                      <span>{{ props.item.MesFinal }}</span>
                    </td>
                    <td class="text-xs-center ellipsis">
                      <span>{{ props.item.nombreAGT }}</span>
                    </td>
                    <td class="text-xs-center ellipsis">
                      <v-btn flat icon small color="datPrimary" @click="fDescargaDocumento(props.item.Identificador)">
                        <v-icon>mdi-download</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
                <template slot="expand" slot-scope="props">

                  <thead class="lighterPrimaryColorBackground">
                    <tr class="px-2">
                      <th v-for="item in dHeadersSubTabla" :key="item.value" :id="item.value" :width="item.width"
                        :class="item.class">{{ item.text }}</th>
                    </tr>
                  </thead>
                  <tr v-for="item in dSubDatosTabla" :key="item.codigoLER" :class="props.expanded ? 'selectedRow' : ''">
                    <td class="text-xs-center " style="vertical-align: middle">
                      <span>{{ item.mes }}</span>
                    </td>
                    <td class="text-xs-center " style="vertical-align: middle">
                      <span>{{ item.codigoLER }}</span>
                    </td>
                    <td class="text-xs-center " style="vertical-align: middle">
                      <span>{{ item.descripcion }}</span>
                    </td>
                    <td class="text-xs-center " style="vertical-align: middle">
                      <span>{{ item.destino }}</span>
                    </td>
                    <td class="text-xs-center " style="vertical-align: middle">
                      <span>{{ item.tratamiento }}</span>
                    </td>
                    <td class="text-xs-center " style="vertical-align: middle">
                      <span>{{ item.cantidad }}</span>
                    </td>
                    <td class="text-xs-center " style="vertical-align: middle">
                      <span>{{ item.uniMed }}</span>
                    </td>
                    <td class="text-xs-center " style="vertical-align: middle">
                      <span>{{ item.reciclaje }}</span>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
import ServiceCertificadosAmbientales from '@/services/srv-certificados-ambientales'
import DatTextFieldCode from '@/components_datadec/DatTextFieldCode'

export default {
  data() {
    return {
      dClassHeader: 'subHeaderTextInTable text-xs-center',
      dContPage: 0,
      dScreenWidth: screen.width,
      dOpenComponent: true,
      dInformeComponente: null,
      dHeadersTable: [],
      dHeadersSubTabla: [],
      dRole: null,
      dTira: null,
      dEmpresa: null,
      dIdOrganizacion: null,
      dDatosFiltros: {},
      dFiltroActivo: false,
      dDatosTabla: [],
      dDataSucursal: {},
      dSelectSucursal: { sucursal: '', nombreSucursal: '' },
      dSubDatosTabla: [],
      dPruebaSubTabla: [],
      dLoading: false,
      dMesFinalSeleccionado: null,
      dMesInicialSeleccionado: null,
      dPaginationPED: { 'sortBy': 'Nombre', 'descending': false, 'rowsPerPage': 10, 'page': 1 },
      dRowsPerPageItemsPED: [5, 10, 25],
      dRowsPerPage: 10,
      dTotalItems: 0,
      dYear: [],
      dIsOnPremise: localStorage.getItem('isOnPremise') === 'yes',
      dAgencias: [],
      dFormatDate: {
        'default': 'DD/MM/YYYY',
        'years': 'YYYY-MM-DD'
      },
      dFechasMensuales: {
        1: this.$t('enero'),
        2: this.$t('febrero'),
        3: this.$t('marzo'),
        4: this.$t('abril'),
        5: this.$t('mayo'),
        6: this.$t('junio'),
        7: this.$t('julio'),
        8: this.$t('agosto'),
        9: this.$t('septiembre'),
        10: this.$t('octubre'),
        11: this.$t('noviembre'),
        12: this.$t('diciembre')
      },
      dFechasSelectMensuales: [
        { 'id': 1, 'text': this.$t('enero') },
        { 'id': 2, 'text': this.$t('febrero') },
        { 'id': 3, 'text': this.$t('marzo') },
        { 'id': 4, 'text': this.$t('abril') },
        { 'id': 5, 'text': this.$t('mayo') },
        { 'id': 6, 'text': this.$t('junio') },
        { 'id': 7, 'text': this.$t('julio') },
        { 'id': 8, 'text': this.$t('agosto') },
        { 'id': 9, 'text': this.$t('septiembre') },
        { 'id': 10, 'text': this.$t('octubre') },
        { 'id': 11, 'text': this.$t('noviembre') },
        { 'id': 12, 'text': this.$t('diciembre') }
      ],
      dUrlCertificado: [],
      dSelectClientIni: { codigo: '', nombre: '' },
      dRequestClient: { empresa: this.$store.getters.getAutenticacion.empresa }
    }
  },
  components: {
    DatTextFieldCode
  },
  props: {
    pInformeComponente: {
      type: Object,
      required: true
    },
    pLimitDate: {
      type: Object,
      required: true
    }
  },
  created() {
    this.fIniciarVariables()
    this.dRole = this.pLimitDate.roleUser
  },
  methods: {
    fIniciarVariables() {
      this.dInformeComponente = this.pInformeComponente
      // ITEMS TABLE
      this.dItemTable = [
        { text: 'prueba', text2: 'prueba' },
        { text: 'prueba2', text2: 'prueba2' }
      ]
      // HEADERS TABLE
      this.dHeadersTable = [
        { text: '', align: 'left', value: '', sortable: false, class: 'px-0', width: '10px', fixed: true },
        { text: this.$t('cliente'), align: 'left', value: 'Cliente', sortable: true, class: '' },
        { text: this.$t('sucursal'), align: 'left', value: 'Sucursal', sortable: true, class: '' },
        { text: this.$t('nombre'), align: 'left', value: 'Nombre', sortable: true, class: '' },
        { text: this.$t('numCertificadoCorto'), align: 'left', value: 'NumCertificado', sortable: true, class: '' },
        { text: this.$t('ejercicio'), align: 'left', value: 'Ejercicio', sortable: true, class: '' },
        { text: this.$t('mesInicial'), align: 'left', value: 'MesInicial', sortable: true, class: '' },
        { text: this.$t('mesFinal'), align: 'left', value: 'MesFinal', sortable: true, class: '' },
        { text: this.$t('agenciaTransporte'), align: 'left', value: 'nombreAGT', sortable: true, class: '' },
        { text: this.$t('descargas'), align: 'left', value: 'descargas', sortable: false, class: '' }
      ]
      // COMPONENTE NUEVO DATADEC
      this.dDataClient = {
        'errorMessages': [],
        'label': 'clienteInicial',
        'rowsPerPage': this.dRowsPerPage,
        'headers': [
          { text: this.$t('cliente'), align: 'left', value: 'codigo', column: 'cliente' },
          { text: this.$t('nombreCliente'), align: 'left', value: 'nombre', column: 'nombre' }
        ],
        'urlWS': 'lovClte',
        'item': { 'codigo': '', 'nombre': '' },
        'filters': { 'codigo': 'cliente', 'nombre': 'nombre' },
        'resultName': 'dataRes',
        'request': this.dRequestClient,
        'default': this.dSelectClientIni,
        'disabled': false,
        'required': false,
        'orderByDefault': 'cliente',
        'orderDefault': 'ASC',
        'isVisibleLoad': true,
        'textCodigo': 'codigo',
        'title': 'seleccionaUnCliente'
      }
      this.dDataSucursal = {
        'errorMessages': [],
        'label': this.$t('sucursal'),
        'rowsPerPage': 10,
        'headers': [
          { text: this.$t('sucursal'), align: 'left', value: 'codigo', column: 'sucursal' },
          { text: this.$t('nombreSucursal'), align: 'left', value: 'nombre', column: 'razonSocial' }
        ],
        'urlWS': 'lovDic',

        'item': { 'codigo': '', 'nombre': '' },
        'filters': { 'codigo': 'sucursal', 'nombre': 'razonSocial' },
        'resultName': 'dataRes',
        'request': null,
        'default': this.dSelectSucursal,
        'disabled': true,
        'required': true,
        'orderByDefault': 'sucursal',
        'orderDefault': 'sucursal',
        'isVisibleLoad': true,
        'textCodigo': 'codigo',
        'title': this.$t('seleccionaUnaSucursal'),
        'client': this.dSelectClientIni.codigo
      }

      if (this.pLimitDate.roleUser === 'CLIENTE') {
        this.dDataSucursal.disabled = false
        this.dDataSucursal.request = {
          empresa: this.$store.getters.getAutenticacion.empresa,
          cliente: this.$store.getters.getAutenticacion.cliente
        }
      }
      // SUBHEADERS TABLE
      this.dHeadersSubTabla = [
        { text: this.$t('mes'), align: 'left', value: 'mes', sortable: true, class: this.dClassHeader, width: '500px' },
        { text: this.$t('codigoLER'), align: 'left', value: 'sucursal', sortable: true, class: this.dClassHeader, width: '500px' },
        { text: this.$t('descripcion'), align: 'left', value: 'nombre', sortable: true, class: this.dClassHeader, width: '500px' },
        { text: this.$t('destino'), align: 'left', value: 'numCertificado', sortable: true, class: this.dClassHeader, width: '500px' },
        { text: this.$t('tratamiento'), align: 'left', value: 'ejercicio', sortable: true, class: this.dClassHeader, width: '500px' },
        { text: this.$t('cantidad'), align: 'left', value: 'mesInicial', sortable: true, class: this.dClassHeader, width: '500px' },
        { text: this.$t('uniMed'), align: 'left', value: 'mesFinal', sortable: true, class: this.dClassHeader, width: '500px' },
        { text: this.$t('reciclaje'), align: 'left', value: 'agenciaTrans', sortable: true, class: this.dClassHeader, width: '500px' }
      ]
      // VARIABLES DE LA STORE LOCAL
      this.dEmpresa = this.$store.getters.getAutenticacion.empresa
      this.dTira = this.$store.getters.getAutenticacion.tira
      this.dIdOrganizacion = this.$store.getters.getAutenticacion.organizacion

      // DATOS FILTROS
      this.dDatosFiltros = {
        empresa: this.dEmpresa,
        tira: this.dTira,
        tipoEmpresa: '0',
        ejercicio: '',
        ejercicioString: '',
        numCertificado: '',
        agenciaTrans: '',
        mesInicial: '',
        mesFinal: '',
        fechaIni: null,
        fechaIniString: '',
        fechaIniMenu: null,
        fechaMinIni: '',
        fechaFin: null,
        fechaFinString: '',
        fechaFinMenu: null,
        fechaMinFin: ''
      }

      const date = new Date()
      for (let i = 2000; i <= date.getFullYear(); i++) {
        this.dYear.push(i)
      }
      this.fGetAgencias()
      this.fLimitFechas()
    },
    fSelectClient(item) {
      if (item && item != null) {
        this.dSelectClientIni.codigo = item.codigo
        this.dSelectClientIni.nombre = item.nombre
        this.dDatosFiltros.idCliente = item.codigo
      }

      if (this.dRoleSelect === "SUCURSAL" && this.dSelectClientIni.codigo === undefined) {
        this.fCleanClient()
      }

      this.dDataSucursal.client = item.codigo
      this.dDataSucursal.request = {
        empresa: this.$store.getters.getAutenticacion.empresa,
        cliente: item.codigo
      }

      if (item.codigo !== '' && item.codigo !== undefined && this.$refs.TablaDeSucursal !== undefined) {
        this.$refs.TablaDeSucursal.fChangeDisabled(false)
      }
    },
    fCleanClient() {
      this.dSelectClientIni = {}
      if (this.$refs.TablaDeSucursal !== undefined) {
        this.$refs.TablaDeSucursal.fChangeDisabled(true)
        this.$refs.TablaDeSucursal.fClear()
      }
      if (this.$refs.TablaDeClient !== undefined) {
        this.$refs.TablaDeClient.fClean()
      }
      this.fClearSucursal()
    },
    fSelectSucursal(item) {
      this.dSelectSucursal.codigo = item.codigo
      this.dSelectSucursal.nombre = item.nombre
      //this.dUsuarioSeleccionado.sucursalClte = item.codigo
    },
    fClearSucursal() {
      this.dDataSucursal.disabled = true
      this.dSelectSucursal = {}
    },
    fCerrarVentana() {
      this.$emit('close')
    },
    fGetFecha(val, tipo) {
      switch (tipo) {
        case 'ini':
          this.dDatosFiltros.fechaIniString = this.$moment(val, this.dFormatDate.years).format(this.dFormatDate.default)
          this.dDatosFiltros.fechaIniMenu = false
          break
        case 'fin':
          this.dDatosFiltros.fechaFinString = this.$moment(val, this.dFormatDate.years).format(this.dFormatDate.default)
          this.dDatosFiltros.fechaFinMenu = false
          break
      }
    },
    fAlert(msg) {
      this.$emit('alert', msg)
    },
    // FUNCTIONS SERVICIOS
    fPrepareCertificates() {
      this.dLoading = true
      this.dDatosTabla = []

      if (this.dRole === 'CLIENTE') {
        this.dDatosFiltros.idCliente = this.$store.getters.getAutenticacion.cliente
      }
      if ((this.dSelectSucursal !== null) && (this.dSelectSucursal !== '')) {
        this.dDatosFiltros.sucursal = this.dSelectSucursal.codigo
      }
      if (this.dRole === 'SUCURSAL') {
        this.dDatosFiltros.idCliente = JSON.parse(localStorage.getItem('datos-autenticacion')).cliente
        this.dDatosFiltros.sucursal = JSON.parse(localStorage.getItem('datos-autenticacion')).sucursal
      }
      const payload = {
        tira: this.dDatosFiltros.tira,
        empresa: this.dDatosFiltros.empresa,
        tipoEmpresa: this.dDatosFiltros.tipoEmpresa,
        agenciaTransporte: this.dDatosFiltros.agenciaTrans,
        fechaInicial: this.dDatosFiltros.fechaIniString,
        fechaFinal: this.dDatosFiltros.fechaFinString,
        clienteInicial: this.dDatosFiltros.idCliente,
        clienteFinal: this.dDatosFiltros.idCliente,
        sucursal: this.dDatosFiltros.sucursal,
        numeroCertificado: this.dDatosFiltros.numCertificado,
        offset: this.dPaginationPED.rowsPerPage * (this.dPaginationPED.page - 1) + 1,
        numRows: this.dPaginationPED.rowsPerPage,
        orderBy: this.dPaginationPED.sortBy,
        order: (this.dPaginationPED.descending) ? 'DESC' : 'ASC'
      }
      ServiceCertificadosAmbientales.getCertificados(payload).then(response => {
        if (this.fRespuestaCorrecta(response)) {
          const datos = response.data.dataRes
          if (datos.length > 0) {
            datos.forEach(item => {
              this.dDatosTabla.push({
                'rn': item.rn,
                'Identificador': item.Identificador,
                'Cliente': item.Cliente,
                'Sucursal': item.Sucursal,
                'Nombre': item.Nombre,
                'NumCertificado': item.NumCertificado,
                'Ejercicio': item.Ejercicio,
                'MesInicial': this.dFechasMensuales[item.MesInicial],
                'MesFinal': this.dFechasMensuales[item.MesFinal],
                'nombreAGT': item.nombreAGT
              })
            })
            this.dTotalItems = response.data.numReg
          }
        }
        this.dLoading = false
      })
    },
    fLimitFechas() {
      if (this.pLimitDate.fechaIniLimit !== '' && this.pLimitDate.fechaIniLimit !== null) {
        this.dDatosFiltros.fechaIni = this.pLimitDate.fechaIniLimit
        this.dDatosFiltros.fechaMinIni = this.$moment(this.pLimitDate.fechaIniLimit, this.dFormatDate.years).format(this.dFormatDate.years)
        this.dDatosFiltros.fechaIniString = this.$moment(this.pLimitDate.fechaIniLimit, this.dFormatDate.years).format(this.dFormatDate.default)
      }
      if (this.pLimitDate.fechaFinLimit !== '' && this.pLimitDate.fechaFinLimit !== null) {
        this.dDatosFiltros.fechaFin = this.pLimitDate.fechaFinLimit
        this.dDatosFiltros.fechaMinFin = this.$moment(this.pLimitDate.fechaFinLimit, this.dFormatDate.years).format(this.dFormatDate.years)
        this.dDatosFiltros.fechaFinString = this.$moment(this.pLimitDate.fechaFinLimit, this.dFormatDate.years).format(this.dFormatDate.default)
      }
    },
    fDescargaDocumento(numCertificado) {
      this.dLoading = true

      const payload = {
        tira: this.dDatosFiltros.tira,
        empresa: this.dDatosFiltros.empresa,
        tipoEmpresa: this.dDatosFiltros.tipoEmpresa,
        identificador: numCertificado
      }

      ServiceCertificadosAmbientales.getDetCertificados(payload).then(response => {
        if (this.fRespuestaCorrecta(response)) {
          const datos = response.data.dataRes.result
          const urls = []
          if (datos.length > 0) {
            datos.forEach(item => {
              urls.push({ 'url': item.URLcertificado })
            })
          }
          if (urls.length > 0) {
            window.open(urls[0].url, '_blank')
          } else {
            this.$emit('alert', '<b>' + this.$t('urlNotFound') + '</b><br>' + this.$t('urlNotFoundDesc'))
          }
        }
        this.dLoading = false
      })
    },
    fGetDetCertificados(props) {
      props.expanded = !props.expanded
      this.dSubDatosTabla = []
      if (props.expanded) {
        this.dLoading = true

        const payload = {
          tira: this.dDatosFiltros.tira,
          empresa: this.dDatosFiltros.empresa,
          tipoEmpresa: this.dDatosFiltros.tipoEmpresa,
          identificador: props.item.Identificador
        }

        ServiceCertificadosAmbientales.getDetCertificados(payload).then(response => {
          if (this.fRespuestaCorrecta(response)) {
            const datos = response.data.dataRes.result
            if (datos.length > 0) {
              datos.forEach(item => {
                this.dSubDatosTabla.push({
                  'mes': item.Mes,
                  'codigoLER': item.CodigoLER,
                  'descripcion': item.DescCodigoLER,
                  'destino': item.Destino,
                  'tratamiento': item.Tratamiento,
                  'cantidad': item.Cantidad,
                  'uniMed': item.UnidadMedida,
                  'reciclaje': item.Reciclaje
                })
              })
            }
          }
          this.dLoading = false
        })
      }
    },
    fGetAgencias() {
      this.dLoading = true;
      const payload = {
        tira: this.dTira,
        empresa: this.dEmpresa
      }
      ServiceCertificadosAmbientales.getAgenciasTrabajo(payload).then(response => {
        if (this.fRespuestaCorrecta(response)) {
          const datos = response.data.dataRes
          if (Array.isArray(datos)) {
            datos.forEach(item => {
              this.dAgencias.push({
                'id': item.AgenciaTransporte,
                'text': item.NombreAgenica
              })
            })
          }
        }

        this.dLoading = false
      })
    },
    // ORDENACION
    fCambiaOrden(column) {
      this.dPaginationPED.page = 1
      this.dPaginationPED.rowsPerPage = this.dRowsPerPage
      if (this.dPaginationPED.sortBy === column) {
        this.dPaginationPED.descending = !this.dPaginationPED.descending
      } else {
        this.dPaginationPED.sortBy = column
        this.dPaginationPED.descending = false
      }
    },
    fSelect(value, filtro) {
      switch (filtro) {
        case 'inicial':
          this.dMesInicialSeleccionado = value
          this.dDatosFiltros.mesInicial = value
          break
        case 'final':
          this.dMesFinalSeleccionado = value
          this.dDatosFiltros.mesFinal = value
          break
        case 'age':
          this.dDatosFiltros.ejercicio = value
          break
        case 'agencia':
          this.dDatosFiltros.agenciaTrans = value
          break
      }
    },
    // VALIDACION
    fCheckValid(value) {
      let finalvalue = false;
      if (value !== undefined && value !== '' && value !== null) {
        finalvalue = true;
      } 
      return finalvalue;
    },
    fRespuestaCorrecta(response) {
      let finalvalue = false;
      if (response.status === 200 && response.data.result !== 'ko' && (response || response.data !== undefined || response.data.dataRes.result !== undefined || response.data.dataRes.result !== null)) {
        finalvalue = true;
      }
      return finalvalue;
    }
  },
  watch: {
    pInformeComponente: {
      handler() {
        this.dInformeComponente = this.pInformeComponente
      }
    },
    dPaginationPED: {
      handler(newPage, oldPage) {
        if (this.dContPage > 0) {
          this.fPrepareCertificates()
        }
        this.dContPage++
      },
      deep: true
    },
    dEjercicioMenu(val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  },
  computed: {
    cRoleUser() {
      return this.dRole
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Informes/CertAmbiental/ShpCertificadoAmbiental.vue